/*ACTIONTYPE*/
export const TIMELINE = 0
export const QUIZ = 1
/*ENDACTIONTYPE*/

/*UNIT*/
export const MINUTES = 0
export const HOURS = 1
export const DAYS = 2
/*END UNIT*/